import axios from '@/axios';

const RESOURCE_NAME = '/trackers-public';

export default {
    getTrackersForApply(filters) {
        return axios.post(`${RESOURCE_NAME}/get-trackers-for-apply`, filters)
    },

    getOpportunitiesIndex(params) {
        return axios.get(`${RESOURCE_NAME}/get-opportunities-index`, { params })
    },

    getTopOpportunities() {
        return axios.get(`${RESOURCE_NAME}/get-top-opportunities`)
    },

    getApplicationInfo(id) {
        return axios.get(`${RESOURCE_NAME}/get-application-info?id=${id}`)
    },

    checkApplicationStatus(id) {
        return axios.get(`${RESOURCE_NAME}/check-application-status?id=${id}`)
    },

    apply(id, data) {
        return axios.post(`${RESOURCE_NAME}/apply?id=${id}`, data)
    },

    getAnswers(trackerId) {
        return axios.get(`${RESOURCE_NAME}/get-application-data?id=${trackerId}`);
    },

    deleteSubmission(id) {
        return axios.post(`${RESOURCE_NAME}/delete-submission?id=${id}`)
    },
}
